module.exports = __webpack_public_path__ + "img/preset-exam.8ae0ec92.png";